<template>
    <div id="cursos" class="courses">
        <b-container fluid>
            <b-row>
                <b-col class="mb-4" lg="12">
                    <h3>Talleres y cursos</h3>
                    <h3>ENERO Y FEBRERO</h3>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="4" class="mb-5">
                    <b-card no-body >
                        <template #header>
                            <h2 class="mb-0">INTRODUCCIÓN AL ENEAGRAMA</h2>
                        </template>

                        <b-card-body>
                            <p class="text-hour">Lunes 23 y 30 de enero y <br>Jueves 6 y 13 de febrero </p>
                            <p class="text-time">11:00 AM a 1:00 PM</p>
                            <p class="text-title mb-1">Curso semanal principios del Eneagrama</p>
                            <p class="text-subtitle mb-1">Andrea Varga</p>
                            <p class="mb-0">Costo: $4500</p>
                            <p class="mb-0">Cupo limitado</p>
                            <b-button v-on:click="showModal('INTRODUCCIÓN AL ENEAGRAMA')">REGÍSTRATE</b-button>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
            
            <b-row>
                <b-col class="text-center">
                    <p class="mb-2" style="font-size: larger;"> <img src="../assets/img/ubi.svg"> Laguna 35, Ampliación Los Alpes, Álvaro Obregón,<br> 01710 Ciudad de México CDMX</p>
                    <p style="font-size: larger;"> <img src="../assets/img/telefono.svg"> +52 1 55 4928 7238</p>
                    <p><b>*Para apartar su lugar se debe pagar el 50% del taller</b></p>
                </b-col>
            </b-row>
        </b-container>
        <b-modal size="xl" id="modal-registro" centered >
            <h3>¡Regístrate a tu curso favorito!</h3>
            <p>Llena el formulario para inscribirte al curso en el que desees participar</p>

            <b-form>
                <b-row>
                    <b-form-group>
                            <div style="display: none;">
                                <b-form-input
                                    id="honeypot"
                                    v-model="honeypot"
                                    placeholder=" "
                                ></b-form-input>
                            </div>
                        </b-form-group>
                    <b-col class="mb-3" lg="6">    
                        <b-form-group id="input-group-1">
                            <div class="align-items-center">
                                <b-form-input
                                    id="input-1"
                                    class="modal-input"
                                    v-model="nombre"
                                    placeholder="Nombre:"
                                    required
                                ></b-form-input>
                            </div>
                        </b-form-group>
                    </b-col>
                    <b-col class="mb-3" lg="6">
                        <b-form-group id="input-group-1">
                            <div class="align-items-center">
                                <b-form-input
                                    id="input-1"
                                    class="modal-input"
                                    v-model="apellido"
                                    placeholder="Apellido:"
                                    required
                                ></b-form-input>
                            </div>
                        </b-form-group>
                    </b-col>
                    <b-col class="mb-3" lg="6">
                        <b-form-group id="input-group-6">
                            <div class="form-floating">
                                <b-form-input
                                    id="input-6"
                                    class="modal-input"
                                    v-model="correo"
                                    placeholder="Email:"
                                    required
                                ></b-form-input>
                            </div>
                        </b-form-group>
                    </b-col>
                    <b-col class="mb-3" lg="6">
                        <b-form-group id="input-group-7">
                            <div class="texta">
                                <b-form-input
                                    id="input-6"
                                    class="modal-input"
                                    v-model="telefono"
                                    placeholder="Teléfono:"
                                    required
                                ></b-form-input>
                            </div>
                        </b-form-group>
                    </b-col>        

                    <b-button class="boton enviar mt-3" v-on:click="sendMessage">Enviar</b-button>
                </b-row>
            </b-form>
        </b-modal>

        <b-modal size="xl" id="modal-confirmacion" centered >
            
            <h1><img class="spark1" src="../assets/img/spark1red.png" alt="Spark"> ¡Haz sido registrado! <img class="spark2" src="../assets/img/sparks2red.png" alt="Spark"></h1>
            <p>Disfruta de tu curso ¡nos vemos pronto!</p>
            
        </b-modal>
    </div>
</template>

<script>
import axios from 'axios'

    export default {
        components: { 
        },
        data() {
            return {
                nombre: '',
                apellido: '',
                correo: '',
                telefono: '',
                honeypot: '',
                curso: '',
                messageSend: '',
                slickOptions: {
                    "focusOnSelect": true,
                    "infinite": false,
                    "speed": 500,
                    "slidesToShow": 3,
                    "slidesToScroll": 1,
                    "touchThreshold": 5
                },
            };
        },
        methods: {
            showModal(curso) {
                this.curso = curso
                this.$bvModal.show('modal-registro')
            },
            async sendMessage() {
                if (this.honeypot) {
                    return;
                }

                if (this.nombre !== '' && this.correo !== '') {
                try {
                    const response = await axios.post('vendor/send-registro.php', {
                        nombre: this.nombre,
                        apellido: this.apellido,
                        correo: this.correo,
                        curso: this.curso,
                        telefono: this.telefono
                    });

                    if (response.data == 200 || response.data == '200') {
                        this.$bvModal.hide('modal-registro')
                        this.$bvModal.show('modal-confirmacion')
                    } else {
                        this.messageSend = 'Error al enviar mensaje, intenta más tarde.';
                    }
                } catch (error) {
                    console.error(error);
                    this.messageSend = 'Error al enviar mensaje, intenta más tarde.';
                }
                } else {
                    this.messageSend = 'Ingresa la información necesaria en los campos.';
                }
            }
        },
    }
</script>

<style scoped>
.courses{
    padding-top: 100px;
    padding-left: 20px;
    padding-right: 20px;
}
h1{
    color: #D37353;
    font-size: 50px;
    font-weight: 600;
}
h2{
    font-size: 35px;
    font-weight: 600;
}
h3{
    color: #D37353;
    font-size: 30px;
    font-weight: 600;
}
p{
    font-size: 15px;
    text-align: left;
}
a{
    color: #BC8F50;
}
.card {
    position: relative;
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-direction: column;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    min-width: 0;
    height: 100%;
    word-wrap: break-word;
    background-clip: border-box;
    border: 1px solid #D37353;
    border-radius: 20px;
}

.card-header {
    padding: 1.25rem;
    margin-bottom: 0;
    min-height: 126px;
    border-top-left-radius: 18px !important;
    border-top-right-radius: 18px !important;
    background-color: #D37353;
    border: 1px solid #D37353;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
}
.card-body{
    padding: 50px;
    color: #BC8F50;
    text-align: center;
}
table{
    text-align: left;
    color: #BC8F50;
}
td{
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 0px;
    padding-bottom: 0px;
}
.text-center,
.text-center p{
    text-align: center;
}
.text-hour{
    font-size: 20px;
    text-decoration: underline;
    font-weight: 600;
    margin-bottom: 0px;
}
.text-time{
    font-size: 20px;
    font-weight: 600;
}
.text-title{
    font-size: 15px;
    font-weight: 700;
}
.text-title span{
    font-weight: 400;
}
.text-subtitle{
    font-style: italic;
    font-size: 15px;
    font-weight: 400;
}
.btn{
    width: 100%;
    max-width: 275px;
    background: #5D867C !important;
    color: #fff !important;
    font-size: 25px;
    border: none !important;
    border-radius: 30px;
    margin-top: 20px;
    margin-bottom: 30px;
}
.spark1{
    text-align: left;
    position: absolute;
    margin-left: -50px;
    margin-top: -10px;
}
.spark2{
    position: absolute;
    /* left: 370px; */
    /* margin-top: -100px; */
}
@media (max-width: 992px){
    .card-body{
        padding: 40px 25px;
    }
    .text-hour,
    .text-time{
        font-size: 17px;
    }
    .btn{
        font-size: 20px;
    }
    h1{
        font-size: 35px;
    }
    h2{
        font-size: 27px;
        font-weight: 600;
    }
    .spark1{
        text-align: left;
        width: 20px;
        position: absolute;
        margin-left: -20px;
        margin-top: -10px;
    }
    .spark2{
        position: absolute;
        width: 20px;
        /* left: 370px; */
        /* margin-top: -100px; */
    }
}
</style>